import { useMemo } from "react";
import { AngularBridge } from "../../other/bridgeSetup/AngularBridge";
import { useLocation } from "react-router-dom";

export const TrackConsumptionPage = () => {
    const location = useLocation();

    const params = useMemo(() => {
        // custom route param logic taken from UI.Pages/Angular/Routes.ts
        const bits = location.pathname.split("/");

        if (bits.length < 3) {
            return {
                tab: "Review"
            };
        }

        const brokerId = bits[2];
        const analystName = decodeURIComponent(bits[3] ?? "");
        const dateFrom = bits[4] ?? "";
        const dateTo = bits[5] ?? "";
        const costingTypeId = bits[6];

        return {
            brokerId,
            analystName,
            dateFrom: new Date(dateFrom),
            dateTo: new Date(dateTo),
            costingTypeId: costingTypeId ? 1 * (costingTypeId as never) : null, // coerce to number
            tab: "Review"
        };
    }, [location.pathname]);

    return (
        <AngularBridge
            name="c-activity-redux"
            props={{
                params,
                hideTabs: true
            }}
        />
    );
};
